import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import { companiesApi } from 'apis/companies';
import { useAppPathParams } from 'utils/url/useAppPathParams';
import { contactLoadFailed, contactLoading, contactNotFound, noContactSelected, } from '../../utils/contactDetails.utils';
import { ContactsDetailsSection } from '../detailsSection/contactsDetailsSection';
import { CompanyInfo } from './components/companyInfo/companyInfo';
import { CompanyRelatedUsers } from './components/companyRelatedUsers/companyRelatedUsers';
export function CompanyDetails() {
    const { id } = useAppPathParams('/contacts/company/:id');
    const [getCompany, { data, isFetching, isError }] = companiesApi.useLazyReadCompanyQuery();
    useEffect(() => {
        if (id) {
            getCompany({ id: id });
        }
    }, [id, getCompany]);
    if (!id) {
        return noContactSelected;
    }
    if (isFetching) {
        return contactLoading;
    }
    if (isError) {
        return contactLoadFailed;
    }
    if (!(data === null || data === void 0 ? void 0 : data.data)) {
        return contactNotFound;
    }
    return (_jsxs(_Fragment, { children: [_jsx(ContactsDetailsSection, { children: _jsx(CompanyInfo, { company: data.data }) }), _jsx(ContactsDetailsSection, Object.assign({ headline: "Related users" }, { children: _jsx(CompanyRelatedUsers, { companyId: data.data.id }) }))] }));
}
